import React, { FC } from 'react';
import { CarNumberProps } from '.';
import useTranslations from '@hooks/useTranslations';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import { useCarStockJourneyCheck } from '@hooks/useCarStockJourneyCheck';

const CarNumberTemplate: FC<CarNumberProps> = ({ className, numCar }) => {
    const { t } = useTranslations();
    const { carDetails } = useCarDetailsDuck();
    const { isStockJourney } = useCarStockJourneyCheck();

    const title = numCar ?? carDetails.orders?.[0]?.numCar;

    // TODO: remove this condition if it will be available in all journeys
    if (isStockJourney && title) {
        return <span className={className}>{`${t('stock.carNumber')} ${title}`}</span>;
    }

    return null;
};
export default CarNumberTemplate;
